import { Zalacznik } from "../../wspolne/zalacznik";

export class DodajSlownikModel {
    projektId: string;
    nazwa: string;
    zalacznik: Zalacznik;
    czyMoznaEdytowac: boolean;
}